import { Container, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import { Heading } from "@chakra-ui/react";
import ProjectsCard from "./ProjectsCard";
import foodapp from "../../assets/simplefoodapp.png";
import gymapp from "../../assets/httpsgym-simple-dev-project.web.app.png";
import portReact from "../../assets/reactportfolio.png";
import binary from "../../assets/binarycloth.png";
import wpPort from "../../assets/wp-profile.png";
import { Link } from "react-router-dom";
const Projects = ({ home, size }) => {
    const projects = [
        {
            screen: foodapp,
            name: "Simple food shop app",
            title: "A simple online food shop",
            about:
                "This is a food selling app. You can add to favorite, add to cart. You can remove from cart. You can filter",
            git: "https://github.com/RifatNime/simpleFoodDeliveryApp",
            server: "https://github.com/",
            live: "https://pringles-food-app-react.netlify.app/",
        },
        {
            screen: gymapp,
            name: "Gym Service Provider App",
            title: "Wholesale tools seller website",
            about:
                "this is a demo website for a wholesale tools manufacturer. in this website user can login also admin can user will see order related options and admin will se managment related options .this is a full functional wholesale website. user can order products give reviews and manage their orders and review. admin can manage everything in this site please visit live site to experience yourself. ",
            git: "https://github.com",
            server: "https://github.com",
            live: "https://gym-simple-dev-project.web.app/",
        },
        {
            screen: binary,
            name: "Binarycloth LTd",
            title: "They build 3D apparel.",
            about:
                "This is a Word-Press custom theme building website. This is a 3d apparel Design company's main website. they're specialized in digital only product development passionate to create believable virtual samples.",
            git: "https://github.com",
            server: "https://github.com",
            live: "https://www.binarycloth.com/",
        },
        {
            screen: portReact,
            name: "Tour Boy",
            title: "Personal Website using react",
            about:
                "This is a website for a travel guide who offers customers many offers by his/her own. this is a simple website user can login and buy his package or contact the guide directly . and theres some travel places also in where customer can know about the tour places they can visit. ",
            git: "https://github.com/JuelHossain/tourboy",
            live: "https://refat-naeem-demo-profolio.netlify.app/",
        },
        {
            screen: wpPort,
            name: "My WP Portfolio",
            title: "This is my personal Wp Base portfolio",
            about: "This is a Word-Press custom theme building website.",
            git: "https://github.com",
            live: "https://rifatwebndev.epizy.com/",
        },
    ];
    return (
        <Container maxW={"container.lg"} className="my-6">
            <Heading size={"md"} className="text-center mt-12 mb-2 font-mono font-bold text-2xl">
                Projects I have done.
            </Heading>
            <hr className="mb-6 mx-60 border-blue-300 dark:border-lime-300" />
            <SimpleGrid columns={[1, 1, 2]} spacing="5">
                {projects.slice(0, size).map((project, index) => {
                    const { screen, name, title, about, git, server, live } =
                        project ?? {};
                    return (
                        <ProjectsCard
                            key={index}
                            screen={screen}
                            name={name}
                            title={title}
                            about={about}
                            git={git}
                            server={server}
                            live={live}
                        />
                    );
                })}
            </SimpleGrid>
            {home && (
                <Text
                    fontSize={"sm"}
                    className="font-mono rounded py-3 text-center my-3 bg-blue-300 dark:bg-lime-300 hover:bg-yellow-300 dark:hover:bg-yellow-300 dark:text-black"
                >
                    Please Visit the Project sections to .
                    <Link className="underline font-bold" to="/projects">
                        See More &rarr;{" "}
                    </Link>
                </Text>
            )}
        </Container>
    );
};

export default Projects;
